
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Guide 2026 : comment réussir sa photo de profil Instagram ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez comment choisir, retoucher et dimensionner votre photo de profil pour un un compte Instagram irrésistible. Soyez remarqué dès le premier clic.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Guide [2026] de la Photo de profil Instagram",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez comment choisir, retoucher et dimensionner votre photo de profil pour un un compte Instagram irrésistible. Soyez remarqué dès le premier clic.",
        },
        // {
        //   hid: "og:image",
        //   property: "og:image",
        //   content: require("~/assets/img/og/og-facebook-apropos.jpg"),
        // },
      ],
    };
  },
};
